import { isSubscriptionPurchase } from "../../../../../../../../types/types/typeguards.js";
const isConfiguratorValid = (state) => {
  const { purchaseType } = state.configurations;
  if (isSubscriptionPurchase(purchaseType)) {
    return !!isDeliveryIntervalValid(state);
  }
  return true;
};
const isDeliveryIntervalValid = ({ configurations }) => {
  const { purchaseType, subscriptionPurchaseConfigurations } = configurations;
  if (isSubscriptionPurchase(purchaseType)) {
    return subscriptionPurchaseConfigurations.deliveryInterval !== null;
  }
  return void 0;
};
const selectors = {
  isConfiguratorValid,
  isDeliveryIntervalValid
};
export {
  selectors
};
//# sourceMappingURL=selectors.js.map
